import PropTypes from 'prop-types'

export default function ParagraphRightAlign({ text, children, className, ...props }) {
  return (
    <p className={`text-right mb-0 ${className ? className :''}`} {...props }>
      {text ? text: null}
      {children}
    </p>
  )
}

ParagraphRightAlign.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.element.isRequired,
    PropTypes.node.isRequired
  ]),
  text: PropTypes.string,
  className: PropTypes.string
}